<template>
	<router-link :to="{ name: routerName, params: { ...params }}" :class="{disabled: !active}">
		<i class="fas fa-pen"></i>
	</router-link>
</template>

<script>
export default {
	name: 'ItemEdit',
	props: {
		routerName: {
			type: String,
			required: true
		},
		params: {
			type: Object,
			required: true
		},
		active: {
			type: Boolean,
			default: true
		}
	}
}
</script>

<style lang="scss" scoped>
	a {
		padding: 3px 0px 0px 5px;
		display: flex;
		background-color: $main-color;
		color:#fff;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		width: 25px;
		height: 28px;
		font-weight: $font-weight-default-bolder;
		font-size: $font-size;
		text-decoration: none;
		&.disabled {
			cursor: default !important;
			pointer-events: none !important;
			opacity: 0.6 !important;
		}
	}
</style>
